/**
 * User: n.gorte
 * Date: 17.09.2020
 * Time: 14:38
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';

import TimeLineItem from './TimeLineItem';
import { DefaultTimeLineItemMessageHeader } from './DefaultTimeLineItemMessageHeader';
import { DefaultChangeRecordTable } from './DefaultChangeRecordTable';

export const DefaultChangeRecordListItem = ({ changeRecord, userMeta, children, headerRenderer }) => {
    const Header = headerRenderer || DefaultTimeLineItemMessageHeader;

    return (
        <TimeLineItem userMeta={userMeta} timestamp={changeRecord.timestamp}>
            <Header changeRecord={changeRecord} userMeta={userMeta}/>

            <div className="my-3">
                {
                    children &&
                    <DefaultChangeRecordTable changeRecord={changeRecord}>
                        {children}
                    </DefaultChangeRecordTable>
                }
            </div>

        </TimeLineItem>
    );
};

DefaultChangeRecordListItem.propTypes = {
    userMeta: PropTypes.object,
    changeRecord: PropTypes.object,
    children: PropTypes.node,
    headerRenderer: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.node])
};



// WEBPACK FOOTER //
// ./js/components/ChangeRecords/DefaultChangeRecordListItem.jsx